import React from 'react'
import TransactionModal from "../TransactionProcessing/TransactionModal";
import ViewIcon from "../../../assets/svgs/viewOnExplorer.svg";
import useStyles from "../TransactionProcessing/transactionModalStyles";
import CloseIcon from "../../../assets/svgs/closeIcon.svg";

function WrongNetworkModal({wrongNetworkOpen,setWrongNetworkOpen}) {
    const classes = useStyles();
    return (
      <div>
        <TransactionModal
          open={wrongNetworkOpen}
          height={"70px"}
          width={"325px"}
        >
          <div>
            <div>
              <img
                src={CloseIcon}
                // style={{
                //   display: "flex",
                //   marginLeft: "auto",
                //   fontWeight: "500",
                //   // transform: "scale(1.4)",
                //   cursor: "pointer",
                //   marginTop: "10px",
                // }}
                className={classes.closeIcon}
                onClick={() => {
                    setWrongNetworkOpen(false);
                }}
              />
            </div>
            <div style={{ color: "#282828"}}>
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: "800",
                  fontSize: "18px",
                  lineHeight: "25px",
                  color: "#282828",
                }}
              >
                Wrong Network
              </div>
              <div
                style={{
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "140%",
                  paddingTop:"8px",
  
                  color: "#696969",
                }}
              >
                Please connect to the Ethereum or Binance network.
              </div>
            </div>
          </div>
        </TransactionModal>
      </div>
    );
}

export default WrongNetworkModal
